<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <h3 class="title text-2xl font-medium">
          {{ $t("dashboard.page_title") }}
        </h3>
      </div>
    </div>
    <div class="md-layout" v-if="hasValidRole(role, Role.Family)">
      <div class="md-layout-item md-size-100">
        <greeting :info="info"></greeting>
      </div>
      <div class="md-layout-item md-size-100">
        <external-link></external-link>
      </div>
    </div>
    <component v-else :is="currentUser"></component>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Role from "@/constants/Role";
import DashboardAdmin from "./DashboadByRole/Admin";
import DashboardTeacher from "./DashboadByRole/Teacher";
import DashboardCounselor from "./DashboadByRole/Counselor";
import DashboardStudent from "./DashboadByRole/Student";
import { hasValidRole } from "@/helpers/role-helper";
import Greeting from "./Components/Gretting";
import ExternalLink from "./Components/ExternalLink";

export default {
  components: {
    ExternalLink,
    Greeting,
    DashboardStudent,
    DashboardCounselor,
    DashboardTeacher,
    DashboardAdmin
  },
  computed: {
    ...mapGetters("user", ["role"]),
    ...mapState("user", ["info"]),
    currentUser() {
      if (hasValidRole(this.role, Role.Teacher)) {
        return DashboardTeacher;
      } else if (hasValidRole(this.role, Role.Counselor)) {
        return DashboardCounselor;
      } else if (hasValidRole(this.role, Role.Student)) {
        return DashboardStudent;
      }
      return DashboardAdmin;
    }
  },
  data() {
    return {
      Role,
      hasValidRole
    };
  }
};
</script>
